var _ellipse, _ellipse2, _ellipse3, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbouticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.476,
    cy: 37.914,
    fill: "#424142",
    rx: 10.262,
    ry: 10.195,
    className: "color424142 svgShape"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 28.197,
    fill: "#424142",
    rx: 10.262,
    ry: 10.194,
    className: "color424142 svgShape"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.524,
    cy: 37.914,
    fill: "#424142",
    rx: 10.262,
    ry: 10.195,
    className: "color424142 svgShape"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#424142",
    d: "M127.925 70.084c-.765-10.705-10.043-19.196-21.368-19.196h-2.162c-7.51 0-14.119 3.739-17.95 9.375-.817-10.657-10.075-19.092-21.364-19.092h-2.162c-11.289 0-20.547 8.436-21.363 19.092-3.831-5.636-10.44-9.375-17.95-9.375h-2.162C10.119 50.888.84 59.379.076 70.084H0v10.929h.051c.504 5.013 4.773 8.941 9.949 8.941h27.234A26.786 26.786 0 0 1 37 86.477c0-.166.01-.311.013-.477H10c-3.309 0-6-2.693-6-5.98v-8.516c0-9.177 7.825-16.643 17.443-16.643h2.162c9.618 0 17.442 7.466 17.442 16.643v.868c1.238-1.981 2.254-3.788 3.952-5.383v-5.203c0-9.176 8.301-16.642 17.919-16.642h2.162C74.699 45.145 83 52.61 83 61.786v5.203c1.698 1.595 2.714 3.401 3.952 5.383v-.868c0-9.177 7.824-16.643 17.442-16.643h2.162c9.618 0 17.443 7.466 17.443 16.643v8.516c0 3.287-2.691 5.98-6 5.98H90.987c.003.166.013.311.013.477a26.79 26.79 0 0 1-.234 3.478H118c5.514 0 10-4.457 10-9.935v-9.936h-.075z",
    className: "color424142 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#424142",
    fillRule: "evenodd",
    d: "M64.995 80.189c.157-.398-.047-.634-.22-.599-.805.161-1.293 1.221-1.692 1.221-.156 0-.29-.156-.29-.289 0-.399.382-.62.672-.91.888-.844 2.041-1.487 3.33-1.487.955 0 1.978.577 1.178 2.732l-6.301 17.041c-.134.332-.378.888-.378 1.243 0 .155.087.31.267.31.665 0 1.131-1.065 1.441-1.065.111 0 .266.135.266.333 0 .642-1.84 2.575-4.084 2.575-.8 0-1.354-.376-1.354-1.221 0-1.065.755-2.886.91-3.264l6.255-16.62zm1.823-5.407c0-.979.843-1.776 1.819-1.776.89 0 1.533.599 1.533 1.509 0 1.022-.845 1.776-1.843 1.776-.91 0-1.509-.599-1.509-1.509z",
    clipRule: "evenodd",
    className: "color424142 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#424142",
    d: "M64 110c-12.683 0-23-10.25-23-22.851 0-12.6 10.317-22.851 23-22.851S87 74.55 87 87.149C87 99.75 76.683 110 64 110zm0-41.728c-10.477 0-19 8.469-19 18.877s8.523 18.877 19 18.877 19-8.469 19-18.877-8.523-18.877-19-18.877z",
    className: "color424142 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbouticon);
export default __webpack_public_path__ + "static/media/abouticon.a1d5e9ad77c113d133e61782409c0b97.svg";
export { ForwardRef as ReactComponent };